<template>
  <div>
    <b-modal
      v-model="isTaxInvoiceShow"
      size="lg"
      header-class="header-tax"
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
    >
      <template #modal-header>
        <div class="w-100">
          <strong class="title-modal">{{
            type == "shipping" ? "รายละเอียดผู้สั่งซื้อ" : "ข้อมูลใบกำกับภาษี"
          }}</strong>
          <b-icon
            icon="x-circle-fill"
            class="float-right close-btn"
            @click="closeModal"
          ></b-icon>
        </div>
      </template>
      <div>
        <div>
          <b-row>
            <b-col sm="2" v-if="type == 'billing'">
              <InputSelect
                title="คำนำหน้า"
                v-model="form.nameTitleId"
                v-bind:options="nameTitleOption"
                valueField="id"
                textField="name"
                :isValidate="$v.form.nameTitleId.$error"
                :v="$v.form.nameTitleId"
                @onDataChange="changeTitleName($event)"
              />
            </b-col>
            <b-col :sm="type == 'shipping' ? 6 : 4">
              <InputText
                textFloat="ชื่อ"
                placeholder=""
                v-model="form.firstname"
                isRequired
                :disabled="getDisableBoolean"
                type="text"
                :isValidate="$v.form.firstname.$error"
                :v="$v.form.firstname"
              />
            </b-col>
            <b-col :sm="type == 'shipping' ? 6 : 6">
              <InputText
                textFloat="นามสกุล"
                placeholder=""
                v-model="form.lastname"
                isRequired
                :disabled="getDisableBoolean"
                type="text"
                :isValidate="$v.form.lastname.$error"
                :v="$v.form.lastname"
              />
            </b-col>
            <b-col sm="6" v-if="type == 'billing'">
              <InputText
                textFloat="เลขประจำตัวผู้เสียภาษี"
                placeholder=""
                v-model="form.tax"
                isRequired
                :disabled="getDisableBoolean"
                type="text"
                :isValidate="$v.form.tax.$error"
                :v="$v.form.tax"
              />
            </b-col>
            <b-col sm="12" v-if="type == 'billing'">
              <b-form-checkbox
                class="pb-2"
                name="delivery-address-cb"
                v-model="sameAddress"
                @change="changeSameAddress($event)"
                >ใช้ข้อมูลที่อยู่ในการจัดส่ง</b-form-checkbox
              >
            </b-col>
            <b-col sm="6">
              <InputText
                textFloat="บ้านเลขที่"
                placeholder=""
                v-model="form.address"
                isRequired
                :disabled="getDisableBoolean"
                type="text"
                :isValidate="$v.form.address.$error"
                :v="$v.form.address"
              />
            </b-col>
            <b-col sm="6">
              <InputText
                textFloat="ถนน"
                placeholder=""
                v-model="form.road"
                isRequired
                :disabled="getDisableBoolean"
                type="text"
                :isValidate="$v.form.road.$error"
                :v="$v.form.road"
              />
            </b-col>
            <b-col sm="6">
              <InputZipcode
                :itemsResults="resultsAddress"
                :value="form.zipcode"
                textFloat="รหัสไปรษณีย์"
                placeholder=""
                type="tel"
                v-model="form.zipcode"
                isRequired
                :isValidate="$v.form.zipcode.$error"
                :v="$v.form.zipcode"
                :maxlength="5"
                :getAddress="getAddress"
                :setAddress="setAddress"
                :clearFields="clearFields"
                :isDisplay="isDisplay"
                ref="Zipcode"
              />
            </b-col>
            <b-col sm="6">
              <InputText
                textFloat="จังหวัด"
                placeholder=""
                v-model="form.province"
                isRequired
                disabled
                type="text"
                :isValidate="$v.form.province.$error"
                :v="$v.form.province"
              />
            </b-col>
            <b-col sm="6">
              <InputText
                textFloat="เขต/อำเภอ"
                placeholder=""
                v-model="form.district"
                isRequired
                disabled
                type="text"
                :isValidate="$v.form.district.$error"
                :v="$v.form.district"
              />
            </b-col>
            <b-col sm="6">
              <InputText
                textFloat="แขวง/ตำบล"
                placeholder=""
                v-model="form.subdistrict"
                isRequired
                :disabled="getDisableBoolean"
                type="text"
                :isValidate="$v.form.subdistrict.$error"
                :v="$v.form.subdistrict"
              />
            </b-col>
            <b-col sm="6" v-if="type == 'shipping'">
              <InputText
                textFloat="หมายเลขโทรศัพท์"
                placeholder=""
                v-model="form.telephone"
                isRequired
                type="text"
                :isValidate="$v.form.telephone.$error"
                :v="$v.form.telephone"
              />
            </b-col>
            <b-col sm="12" v-if="type == 'shipping'">
              <InputTextArea
                textFloat="รายละเอียดเพิ่มเติม"
                type="text"
                v-model="form.shippingNote"
                rows="3"
                placeholder=""
              />
            </b-col>
          </b-row>
        </div>
        <div class="w-100">
          <b-button class="float-left gray-btn" @click="closeModal">
            ยกเลิก
          </b-button>
          <b-button class="float-right purple-btn" @click="checkForm">
            บันทึกแบบร่าง
          </b-button>
        </div>
      </div>
    </b-modal>
    <ModalLoading ref="modalLoading" :hasClose="false" />
    <ModalAlertError ref="modalAlertError" :text="modalMessage" />
  </div>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import InputSelect from "@/components/inputs/InputSelect";
import InputZipcode from "@/components/inputs/InputZipcode";
import InputTextArea from "@/components/inputs/InputTextArea";
import ModalLoading from "@/components/modal/alert/ModalLoading";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import { required, requiredIf, minValue } from "vuelidate/lib/validators";
export default {
  name: "TaxInvoice",
  components: {
    InputText,
    InputSelect,
    InputZipcode,
    InputTextArea,
    ModalLoading,
    ModalAlertError,
  },
  props: {
    id: {
      type: Number,
      isRequired: true,
    },
    shippingAddress: {
      type: Object,
      isRequired: true,
    },
    billingAddress: {
      type: Object,
      isRequired: true,
    },
    nameTitleOption: {
      type: Array,
      isRequired: true,
    },
  },
  data() {
    return {
      isTaxInvoiceShow: false,
      getDisableBoolean: false,
      modalMessage: "",
      type: "",
      form: {
        id: 0,
        firstname: "",
        lastname: "",
        address: "",
        road: "",
        province: "",
        district: "",
        subdistrict: "",
        zipcode: "",
        tax: null,
        nameTitleId: 0,
        zipcodeExternalId: null,
        email: null,
        telephone: null,
      },
      sameAddress: false,
      resultsAddress: [],
      isDisplay: false,
    };
  },
  validations: {
    form: {
      nameTitleId: {
        required: requiredIf(function() {
          return this.type == "billing";
        }),
      },
      firstname: { required },
      lastname: { required },
      tax: {
        required: requiredIf(function() {
          return this.type == "billing";
        }),
      },
      address: { required },
      road: { required },
      province: { required },
      zipcode: { required },
      zipcodeExternalId: { required },
      district: { required },
      subdistrict: { required },
      telephone: {
        required: requiredIf(function() {
          return this.type == "shipping";
        }),
      },
    },
  },
  computed: {
    checkSameAddress() {
      if (
        this.type == "billing" &&
        this.form.address == this.shippingAddress.address &&
        this.form.road == this.shippingAddress.road &&
        this.form.province == this.shippingAddress.province &&
        this.form.district == this.shippingAddress.district &&
        this.form.subdistrict == this.shippingAddress.subdistrict &&
        this.form.zipcode == this.shippingAddress.zipcode &&
        this.form.zipcodeExternalId == this.shippingAddress.zipcodeExternalId
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    openModal(type) {
      this.type = type;
      this.isTaxInvoiceShow = true;
      if (this.type == "shipping") {
        this.form = this.shippingAddress;
      } else {
        this.form = this.billingAddress;
      }
      this.isDisplay = this.form.zipcode ? true : false;
    },
    closeModal() {
      this.isTaxInvoiceShow = false;
    },
    checkForm() {
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        return;
      } else {
        this.submitForm();
      }
    },
    submitForm() {
      this.$refs.modalLoading.show();
      this.axios
        .patch(
          `${this.$baseUrl}/Order/TNL/${this.id}/Address/${
            this.type == "shipping" ? "1" : "2"
          }`,
          this.form
        )
        .then((data) => {
          this.$refs.modalLoading.hide();
          if (data.result == 1) {
            this.closeModal();
          } else {
            this.modalMessage = data.message;
            this.$refs.modalAlertError.show();
          }
        });
    },
    changeTitleName(id) {
      this.form.nameTitleId = id;
    },
    changeSameAddress(value) {
      if (value) {
        this.form.address = this.shippingAddress.address;
        this.form.road = this.shippingAddress.road;
        this.form.province = this.shippingAddress.province;
        this.form.district = this.shippingAddress.district;
        this.form.subdistrict = this.shippingAddress.subdistrict;
        this.form.zipcode = this.shippingAddress.zipcode;
        this.form.zipcodeExternalId = this.shippingAddress.zipcodeExternalId;
        this.isDisplay = this.shippingAddress.zipcode ? true : false;
        this.$refs.Zipcode.setResult({
          id: this.form.zipcodeExternalId,
          zipcode: this.form.zipcode,
          provinceInfo: {
            provinceNameLocal: this.form.province,
          },
          districtInfo: {
            districtNameLocal: this.form.district,
          },
        });
      } else {
        this.form.address = "";
        this.form.road = "";
        this.form.province = "";
        this.form.district = "";
        this.form.subdistrict = "";
        this.form.zipcode = "";
        this.form.zipcodeExternalId = null;
        this.$refs.Zipcode.clear();
      }
    },
    clearFields() {
      this.form.zipcode = "";
      this.form.district = "";
      this.form.province = "";
      this.isDisplay = false;
    },
    setAddress(selectedItem) {
      this.form.zipcode = selectedItem.zipcode;
      this.form.district = selectedItem.districtInfo.districtNameLocal;
      this.form.province = selectedItem.provinceInfo.provinceNameLocal;
      this.form.zipcodeExternalId = selectedItem.id;
      this.isDisplay = true;
    },
    getAddress(zipcode) {
      this.axios
        .get(`${this.$baseUrl}/transaction/address?zipcode=${zipcode}`)
        .then((data) => {
          if (data.result == 1) {
            this.resultsAddress = data.detail;
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.text-title {
  color: #404040;
}
.purple-btn {
  background-color: #8a44c3;
  color: #ffffff;
}
.gray-btn {
  background-color: #575757;
  color: #ffffff;
}
::v-deep .header-tax {
  background: #eae2f3;
}
.close-btn {
  cursor: pointer;
}
</style>
